<div (keyup.enter)="confirm()" class="content">
  <Label class="tokenLabel" i18n>The user or password is not correct</Label>
</div>
<div>
  <button class="confirmButton" mat-button (click)="confirm()" i18n>OK</button>
</div>
